export default __webpack_public_path__ + "static/media/whychooseicon4.51176772.png";